<template>
    <div id="users-table" class="users-table-container">
      <vs-table
        ref="table"
        noDataText="Sem dados disponíveis"
        pagination
        :max-items="itemsPerPage"
        search
        :data="users"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mb-4 mr-4"
          >
            <div
              class="
                p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                cursor-pointer flex items-center justify-between font-medium
              "
            >
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                      users.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : users.length
                }} de {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
  
        <template slot="thead">
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="username">Usuário</vs-th>
          <vs-th sort-key="role">Permissão</vs-th>
          <vs-th sort-key="role">Departamento</vs-th>
          <vs-th>Ações</vs-th>
        </template>
  
        <template slot-scope="{data}">
          <tbody>
            <vs-tr 
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
              :state="selectedUsers.indexOf(tr.id) >= 0 ? 'primary': 'true'"
            >
  
              <vs-td>
                <p class="product-email font-medium truncate">{{ tr.email }}</p>
              </vs-td>
  
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>
  
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.username }}</p>
              </vs-td>
  
              <vs-td>
                <p class="product-username font-medium truncate">
                  {{ tr.role ? tr.role.display_name : '' }}
                </p>
              </vs-td>
  
              <vs-td>
                <p class="product-username font-medium truncate">
                  {{ tr.userDepartment ? tr.userDepartment.name : '' }}
                </p>
              </vs-td>
  
              <vs-td class="whitespace-no-wrap">
                <vs-button
                  :color="selectedUsers.indexOf(tr.id) >= 0 ? '#ddd' : 'primary'"
                  @click="chooseThisUser(tr.id)"
                >
                  Escolher
                </vs-button>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </template>
  
  <script>

    export default {
      name: 'users-table',
      props: {
        selectedUsers: Array
      },
      data() {
        return {
          itemsPerPage: 4,
          isMounted: false,
          addNewDataSidebar: false,
          sidebarData: {},
        }
      },
      computed: {
        currentPage() {
          if (this.isMounted) {
            return this.$refs.table.currentx
          }
  
          return 0
        },
        users() {
          return this.$store.getters.users;
        },
        queriedItems() {
          return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
        }
      },
      methods: {
        chooseThisUser(userId) {
          this.$emit("chooseUser", userId)
        }
      },
      async created() {
        this.$store.dispatch('getAllUsers')
          const users = this.$store.getters.users;
          this.selectedUsers = users
      },
      mounted() {
        this.isMounted = true;
      }
    }
  </script>
  
  <style lang="scss">
    #users-table {
      .vs-con-table {
  
        .product-name {
          max-width: 23rem;
        }
  
        .vs-table--header {
          display: flex;
          flex-wrap: wrap-reverse;
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          > span {
            display: flex;
            flex-grow: 1;
          }
  
          .vs-table--search{
            padding-top: 0;
  
            .vs-table--search-input {
              padding: 0.9rem 2.5rem;
              font-size: 1rem;
  
              &+i {
                left: 1rem;
              }
  
              &:focus+i {
                left: 1rem;
              }
            }
          }
        }
  
        .vs-table {
          border-collapse: separate;
          border-spacing: 0 1.3rem;
          padding: 0 1rem;
  
  
          tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 10px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
              &.img-container {
                span {
                  display: flex;
                  justify-content: flex-start;
                }
  
                .product-img {
                  height: 110px;
                }
              }
            }
            td.td-check{
              padding: 20px !important;
            }
          }
        }
  
        .vs-table--thead{
          th {
            padding-top: 0;
            padding-bottom: 0;
  
            .vs-table-text{
              text-transform: uppercase;
              font-weight: 600;
            }
          }
          th.td-check{
            padding: 0 15px !important;
          }
          tr{
            background: none;
            box-shadow: none;
          }
        }
  
        .vs-table--pagination {
          justify-content: center;
        }
      }
    }
  </style>
  